import { createContext } from 'react';

/**
 * Context for submitting a chat query from the rep dashboard widget.
 * Provided by the chat app when rendering pages inline.
 * When undefined (e.g. in the builder), related question buttons show but do nothing.
 */
export const RepDashboardSubmitQueryContext = createContext<
  ((query: string) => void) | undefined
>(undefined);
